import styled from "styled-components";

const TooltipWrapper = styled.div`
  margin-left: auto;
`;

export default TooltipWrapper;
